export default {
  code: "Code",
  forms: "Forms",
  title: "Title",
  description: "Description",
  status: "Status",
  numberOfQuestions: "Questions",
  createdAt: "Created",
  updatedAt: "Updated",
  noDescription: "No description",
  statusTypes: {
    draft: "Draft",
    published: "Published",
    archived: "Archived",
  },
  archived: "Archived",
  published: "Published",
  createForm: "Create Form",
  formMeta: "Form Metadata",
  saveForm: "Save Form",
  formTitle: "Form Title",
  editQuestion: "Edit",
  required: "Required",
  updateQuestion: "Update Question",
  discardQuestion: "Discard Question",
  addAnotherQuestion: "Add another question",
  hasErrors: "Has errors",
  formTitleInfo:
    "This is the title of the form that will be displayed to users. It is a required field.",
  formDescription: "Form Description",
  formDescriptionInfo:
    "This is the description of the form that will be displayed to users. It is typically displayed below the title before the questions. It is an optional field.",
  addQuestion: "Add Question",
  addQuestionDropdownLabel: "Add Question - Choose question type",
  questions: "Questions",
  questionTitle: "Question Title",
  questionTitleInfo:
    "This is the title of the question that will be displayed to users. It is a required field.",
  questionTitlePlaceholder: "Replace with your question title",
  questionDescription: "Question Description",
  questionDescriptionInfo:
    "This is the description of the question that will be displayed to users. It is typically displayed below the question title. It is an optional field.",
  questionDescriptionPlaceholder: "Replace with your question description",
  questionType: "Question Type",
  questionTypeInfo:
    "This is the type of the question that will be displayed to users. It is a required field.",
  questionRequired: "Required",
  questionRequiredInfo:
    "This indicates whether the question is required or not. If a question is required, users must answer it before submitting the form.",
  questionOptions: "Options",
  addOption: "Add Option",
  optionValue: "Value",
  optionLabel: "Label",
  questionTypes: {
    text: "Text",
    textarea: "Descriptive Text",
    single_select_radio: "Single Select (Radio)",
    multi_select_checkbox: "Multi Select (Checkbox)",
    file: "File Upload",
    image: "Image Upload",
  },
  editQuestionTypesDescriptions: {
    text: "A simple text input for short answers.",
    textarea: "A larger text area for longer, descriptive answers.",
    single_select_radio: "A single choice question with radio buttons.",
    multi_select_checkbox: "A multiple choice question with checkboxes.",
    file: "Allows users to upload files.",
    image: "Allows users to upload images.",
  },
  formDeleted: "Form deleted successfully",
  formActions: "Form actions",
  deleteFormError: "Failed to delete form",
  confirmDeleteMessage:
    "Are you sure you want to delete the selected forms? This action cannot be undone.",
  confirmDeleteTitle: "Delete Forms",
  bannerImage: "Banner Image",
  bannerImagePlaceholder: "Upload a banner image for the form",
  openFormInBrowser: "Open form in browser",
  formNeedsToBePublished:
    "The form needs to be published before it can be opened in the browser.",
};
